import { MentionData } from "@draft-js-plugins/mention";

export default function filterSuggestions(
  searchValue: string,
  suggestions: MentionData[],
): MentionData[] {
  const value = searchValue.toLowerCase();

  const filteredSuggestions = suggestions.filter(
    (suggestion) =>
      !value ||
      suggestion.name.toLowerCase().indexOf(value) > -1 ||
      suggestion.email.toLowerCase().indexOf(value) > -1,
  );
  const length =
    filteredSuggestions.length < 5 ? filteredSuggestions.length : 5;
  return filteredSuggestions.slice(0, length);
}
